var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_5022)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#6C757E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0805 23.3876C47.9185 23.3207 45.3357 22.288 41.3624 21.5767C40.9019 19.9258 40.4069 19.1927 40.2554 19.0007C40.0364 18.7229 39.723 18.5309 39.369 18.4582C39.276 18.4393 37.0696 18 33.9978 18C30.9259 18 28.766 18.4422 28.6745 18.4611C28.3265 18.5338 28.0161 18.7244 27.7986 18.9993C27.6471 19.1913 27.1506 19.92 26.6931 21.5665C22.6868 22.2778 20.0785 23.3222 19.9165 23.3876C19.1545 23.6989 18.7975 24.5513 19.117 25.2916C19.375 25.8851 19.99 26.2065 20.6199 26.1585C20.7339 28.2764 20.9199 30.4684 21.2304 32.7447C22.5053 42.1033 24.6847 47.1418 25.1077 48.0567C25.2757 48.4204 25.5892 48.6996 25.9762 48.832C26.7756 49.1055 29.72 50 34.0008 50C38.2815 50 41.2244 49.1069 42.0238 48.832C42.4108 48.6996 42.7243 48.4189 42.8923 48.0567C43.3168 47.1418 45.4962 42.0989 46.7711 32.7447C47.0831 30.4538 47.2676 28.2662 47.3801 26.1585C47.9965 26.2604 48.6295 25.8676 48.883 25.2902C49.2025 24.5498 48.8455 23.6989 48.0835 23.3876H48.0805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_5022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDelete);
export default __webpack_public_path__ + "static/media/audio-delete.b44aa8742dee3d3b546f11942d8ef1f7.svg";
export { ForwardRef as ReactComponent };